import * as actionTypes from "./SalesOrderType";

const INITIAL_STATE = {
  salesOrderList: [],
  orderNoList: [],
  filterCustomerList: [],
  items: [],
  itemList: [],
  customersList: [],
  taxList: [],
  warehouseList: [],
  costcenterList: [],
  paytermsList: [],
  supplyList: [],
  salesempList: [],
  salesOrder: null,
  salesOrderById: {},
  customerAddress: [],
  customerAddressList: [],
  prjList: [],
  seriesList: [],
  hsnList: [],
  salesQuote: null,
  salesQuoteList: [],
  attachmentList: [],
  advanceFilterList: [],
  itemInfo: null,
  customerInfo: [],
  duplicateDoc: null,
  defaultCurrency: null,
  kitItem: null,
  flexiQuote: null,
  basicFilterData: [],
  emailContent: null,
  relationshipTree: null,
  orderCategoryList: [],
  priceList: [],
  bpMasterAddress: [],
  taxCodes: [],
  statusCount: [],
  salesOrderItemListing: [],
  attachmentData: [],
  promotionType: [],
};

const SalesOrderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETBPMASTERADDRESS:
      return {
        ...state,
        bpMasterAddress: action.payload,
      };
    case actionTypes.SETTAXCODE:
      return {
        ...state,
        taxCodes: action.payload,
      };
    case actionTypes.SETPRICELIST:
      return {
        ...state,
        priceList: action.payload,
      };
    case actionTypes.SETORDERCATEGORY:
      return {
        ...state,
        orderCategoryList: action.payload,
      };
    case actionTypes.SETORDERNOLIST:
      return {
        ...state,
        orderNoList: action.payload.list,
      };
    case actionTypes.SETFILTERCUSTOMERLIST:
      return {
        ...state,
        filterCustomerList: action.payload.list,
      };
    case actionTypes.SETSALESORDERLIST:
      return {
        ...state,
        salesOrderList: action.payload,
      };
    case actionTypes.SETITEMS:
      return {
        ...state,
        items: action.payload.list,
      };
    case actionTypes.SETCUSTOMERLIST:
      return {
        ...state,
        customersList: action.payload.list,
      };
    case actionTypes.SETPAYTERMSLIST:
      return {
        ...state,
        paytermsList: action.payload.list,
      };
    case actionTypes.SETSUPPLYLIST:
      return {
        ...state,
        supplyList: action.payload.list,
      };
    case actionTypes.SETSALESEMPLIST:
      return {
        ...state,
        salesempList: action.payload.list,
      };
    case actionTypes.SETCUSTOMERADDRESS:
      return {
        ...state,
        customerAddress: action.payload.list,
      };
    case actionTypes.SETCUSTOMERADDRESSLIST:
      return {
        ...state,
        customerAddressList: action.payload.list,
      };
    case actionTypes.SETWHSELIST:
      return {
        ...state,
        warehouseList: action.payload.list,
      };
    case actionTypes.SETPRJLIST:
      return {
        ...state,
        prjList: action.payload.list,
      };
    case actionTypes.SETTAXLIST:
      return {
        ...state,
        taxList: action.payload.list,
      };
    case actionTypes.SETCOSTCENTERLIST:
      return {
        ...state,
        costcenterList: action.payload.list,
      };
    case actionTypes.SETITEMLIST:
      return {
        ...state,
        itemList: action.payload,
      };
    case actionTypes.SETSERIESLIST:
      return {
        ...state,
        seriesList: action.payload.list,
      };
    case actionTypes.SETHSNLIST:
      return {
        ...state,
        hsnList: action.payload.list,
      };
    case actionTypes.SETSALESORDER:
      return {
        ...state,
        salesOrder: action.payload.data,
      };
    case actionTypes.SALESORDERBYID:
      return {
        ...state,
        salesOrderById: action.payload,
      };
    case actionTypes.CLEARDOC:
      return {
        ...state,
        salesOrder: null,
        itemList: [],
        salesOrderById: {},
        customerAddress: [],
        customerAddressList: [],
        salesQuote: null,
        salesQuoteList: [],
        itemInfo: null,
        customerInfo: [],
        flexiQuote: null,
        kitItem: null,
        relationshipTree: [],
      };
    case actionTypes.SETSALESQUOTE:
      return {
        ...state,
        salesQuote: action.payload.data,
      };
    case actionTypes.SETCOPYFROMQUOTELIST:
      return {
        ...state,
        salesQuoteList: action.payload.list,
      };
    case actionTypes.SETATTACHMENTLIST:
      return {
        ...state,
        attachmentList: action.payload.list,
      };
    case actionTypes.SETADVANCEFILTERLIST:
      return {
        ...state,
        advanceFilterList: action.payload.list,
      };
    case actionTypes.SETITEMINFO:
      return {
        ...state,
        itemInfo: action.payload.data,
      };
    case actionTypes.SETCUSTOMERINFO:
      return {
        ...state,
        customerInfo: action.payload.data,
      };
    case actionTypes.SETDUPLICATEDOC:
      return {
        ...state,
        duplicateDoc: action.payload.data,
      };
    case actionTypes.SETDEFAULTCURRENCY:
      return {
        ...state,
        defaultCurrency: action.payload.data,
      };
    case actionTypes.SETKITITEM:
      return {
        ...state,
        kitItem: action.payload.data,
      };
    case actionTypes.SETFLEXIQUOTEDETAILS:
      return {
        ...state,
        flexiQuote: action.payload.data,
      };
    case actionTypes.SETSALESORDERBASICFILTERDATA:
      return {
        ...state,
        basicFilterData: { ...action.payload },
      };
    case actionTypes.SETEMAILCONTENT:
      return {
        ...state,
        emailContent: action.payload.data,
      };
    case actionTypes.SETRELATIONSHIPTREE:
      return {
        ...state,
        relationshipTree: action.payload.data,
      };
    case actionTypes.SETSALESORDERCOUNT:
      return {
        ...state,
        statusCount: action.payload,
      };
    case actionTypes.SETSALESORDERITEMLISTING:
      return {
        ...state,
        salesOrderItemListing: action.payload,
      };
    case actionTypes.SETATTACHMENTDATA:
      return {
        ...state,
        attachmentData: action.payload,
      };
    case actionTypes.SETPROMOTIONTYPE:
      return {
        ...state,
        promotionType: action.payload.data.Data,
      };
    default:
      return state;
  }
};

export default SalesOrderReducer;
